<template>
<transition name="slide">
  <div class="tweet-text">
    <div class="user">
      <div class="user-icon" :style="{
        backgroundImage: `url(${userIconSrc})`
      }"></div>
      <div class="user-name">{{userName}}</div>
    </div>
    <div class="text">{{displayText}}</div>
  </div>
</transition>
</template>

<style scoped>
  .tweet-text {
    color: white;
    background: #33333380;
    font-size: 10pt;
    text-align: left;
    padding: 0 5px 5px 5px;
  }
  .user {
    position: relative;
    top: -25px;
    margin-bottom: -25px;
  }
  .user-icon {
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-size: cover;
    background-position: center;
  }
  .user-name {
    display: inline-block;
    font-weight: bold;
  }
  .text {
    font-size: 9pt;
  }
  /* animation */
  .slide-enter-active, .slide-leave-active {
    transition: all 300ms 0.15s cubic-bezier(.41,.8,.67,1);
  }
  .slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    bottom: -100px
  }
</style>

<script>
export default {
  name: 'TweetText',
  props: {
    userIconSrc: String,
    userName: String,
    text: String
  },
  data () {
    return {

    }
  },
  computed: {
    displayText () {
      return (this.text || '').replace(/https:\/\/t\.co\/[0-9a-zA-Z]+$/, '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TweetText.vue